<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="carNo" label="车牌号">
        <el-input v-model="searchModel.carNo" placeholder="请输入" clearable @keyup.enter.native="getTableData(true)"></el-input>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" @onRefresh="getTableData()">
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border height="100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="carNo" label="车牌号" align="center"></el-table-column>
        <el-table-column prop="typeName" label="车辆类型" align="center"></el-table-column>
        <el-table-column prop="driveExpire" label="行驶证到期日" align="center"></el-table-column>
        <el-table-column prop="checkExpire" label="年检到期日" align="center"></el-table-column>
        <el-table-column prop="upkeepTime" label="保养日期" align="center"></el-table-column>
        <el-table-column label="车辆图片" headeralign="center" min-width="200">
          <template v-slot="{ row }">
            <div class="img-list">
              <el-image
                v-for="(url, imgIndex) in row.imgList"
                :key="imgIndex"
                style="width: 44px; height: 44px"
                :src="url"
                :preview-src-list="row.imgList"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="保单文件" headeralign="center" min-width="140">
          <template v-slot="{ row }">
            <el-link
              type="primary"
              :underline="true"
              v-for="(file, index) in row.files"
              :key="index"
              :href="`${$imgUrl}${file.filePath}`"
              target="_blank"
            >
              {{ file.fileName }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间" width="140" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>

        <el-table-column label="操作" width="140" align="center">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleEdit(row)">编辑</el-link>
            <el-link type="danger" @click="handleDelete(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <CarEdit :visible.sync="editVisible" :activeInfo="activeRowInfo" @refresh="getTableData()" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import CarEdit from './components/CarEdit';

import { getDictsByCode, getCarList, deleteCar } from '@/api/system';

export default {
  components: { TableHeader, CarEdit },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        carNo: '',
        type: '',
        dateRange: []
      },
      carTypeOptions: [],
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      tableSelection: [],
      // 弹窗
      activeRowInfo: {},
      editVisible: false
    };
  },
  filters: {
    typeFilter(val) {
      const item = this.carTypeOptions.find(item => item.value === val);
      return item?.name || '';
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getCarList({ ...this.searchModel, startTime, endTime });

      this.dataTotal = data.count;
      const tableData = data.list || [];
      tableData.forEach(item => {
        if (item.pics) {
          if (this.isJSONObjectOrArray(item.pics)) {
            const allFiles = JSON.parse(item.pics);
            item.pics = allFiles?.pics || '';
            item.files = allFiles?.files || [];
          } else {
            item.pics = item?.pics || '';
            item.files = [];
          }
        } else {
          item.pics = '';
          item.files = [];
        }
        if (item.pics) {
          item.imgList = item.pics.split(',').map(item => {
            return this.$imgUrl + item;
          });
        } else {
          item.imgList = [];
        }
        item.typeName = this.formatCarType(item.type);
      });
      this.tableData = tableData;

      this.tableLoading = false;
    },
    isJSONObjectOrArray(str) {
      if (typeof str !== 'string') return false;
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
      } catch (e) {
        return false;
      }
    },
    formatCarType(val) {
      const item = this.carTypeOptions.find(item => item.value === val);
      return item?.name || '';
    },
    handleAdd() {
      this.activeRowInfo = {};
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowInfo = row;
      this.editVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteCar({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data ?? [];
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  async activated() {
    if (this.carTypeOptions.length === 0) {
      await this.getDictsByCode('car_type', 'carTypeOptions');
    }
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  .el-table__cell {
    position: relative;
  }
  .logo-box {
    padding-left: 40px;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 40px;
      height: auto;
    }
  }
}
.img-list {
  display: flex;
  flex-wrap: wrap;
  .el-image {
    margin: 0 10px 10px 0;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
  }
}
</style>
